import NavbarOther from "../components/NavbarOther/NavbarOther";
import productData from "../products.json";
import Product from "../components/Product/Product";
import "./StoneSheets.css";
import Footer from "../components/Footer/Footer";
import { Helmet } from "react-helmet";

const StoneSheets = () => {
  return (
    <>
      <Helmet>
        <title> Flexible Stone Veneer | Flexible Natural Stone | Flexible Stone Veneer Manufacturer In India  </title>
        <meta
          name="description"
          content="Explore Flexible Stone Veneer's high-quality natural stone veneer products. Perfect for both interior and exterior applications, our stone veneers offer beauty and durability for your project."
        />
        <meta
          name="keywords"
          content="flexible stone veneer, thin stone veneer, stone veneer, slate stone veneer, marble stone veneer, sandstone veneer, translucent stone veneer, backlit stone veneer, flexible stone veneer manufacturer, stone veneer manufacturer in india, stone veneer manufacturer, flexible stone veneer manufacturer in india, Elastyczna okładzina kamienna, okładzina kamienna, producenci okładziny kamiennej w Indiach, producenci elastycznej okładziny kamiennej w Indiach, elastyczny kamień, okładzina kamienna Indie, elastyczna okładzina kamienna Indie, płyty kamienne, flexystone, гибкий каменный шпон, каменный шпон, производители каменного шпона в Индии, производители гибкого каменного шпона в Индии, гибкий камень, каменный шпон Индия, гибкий каменный шпон Индия, каменные листы, гибкий камень"
        />
        <meta
          property="og:title"
          content={`Flexible Stone Veneer`}
        />
        <meta
          property="og:description"
          content={`High-quality, durable, and beautiful stone veneer perfect for any application. Learn more about our premium stone products.`}
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:url"
          content={`https://www.stone-sheet.com/StoneSheet`}
        />
      </Helmet>

      <NavbarOther></NavbarOther>
      <div className="product-page">
        {productData.map((product, index) => (
          <Product key={index} product={product} />
        ))}
      </div>
      <Footer></Footer>
    </>
  );
};

export default StoneSheets;
